export const fusionScript = (cname) => {
  return `<script type="text/javascript" id="sgjs">
  (function(){
    var sgcname = '${cname}';

    function ldsgjs(){
      if (typeof window.__sgjsld != 'undefined') {
        return; 
      }
      
      window.__sgjsld = 1;

      var sgjs = document.createElement('script');

      sgjs.type = 'text/javascript';
      sgjs.async = true;
      sgjs.id = 'sgjssync';
      sgjs.src = '//' + sgcname + '/fusion/a.js';
      var x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(sgjs, x);
    };

    setTimeout(ldsgjs, 10);

    document.readyState !== 'complete' ? (window.attachEvent ? window.attachEvent('onload', ldsgjs) : window.addEventListener('load', ldsgjs, false)) : ldsgjs();
  })();
<\/script>`;
};
